
export const enum DataPointTypes {
    Yearly = "Yearly",
    Monthly = "Monthly",
    HalfYearly = "Half Yearly",
    Quaterly = "Quaterly"
}